import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuxiliaresModule } from '../../auxiliares/auxiliares.module';
import { DashboardRoutingModule } from './dashboard.routing.module';

@NgModule({
  declarations: [
    DashboardComponent
  ],
  imports: [
    CommonModule,
    AuxiliaresModule,
    DashboardRoutingModule,
  ]
})
export class DashboardModule { }
